import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, computed, effect, OnInit, signal, viewChild } from '@angular/core';

import { IColumn } from '@shared/interceptors/column.interface';
import { SessionContent } from '@app/shared/models/session.model';
import { SESSION_STATUS } from '@app/shared/constants/global.constant';
import { TableComponent } from '@shared/components/table-component/table.component';

import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-counter-detail',
  imports: [CommonModule, FormsModule, TableComponent, Dialog],
  templateUrl: './counter-detail.component.html',
  styleUrl: './counter-detail.component.scss',
})
export class CounterDetailComponent implements OnInit {
  statusColumnTemplate = viewChild('statusColumnTemplate');
  respondTimeColumnTemplate = viewChild('respondTimeColumnTemplate');

  displayDialog = signal<boolean>(false);
  selectedItem = signal<SessionContent | null>(null);

  cols: IColumn[] = [];
  sessionStatus = SESSION_STATUS;

  getTableData = computed(() => {
    const selected = this.selectedItem();
    const serverInfo = selected?.serverPingInformation;

    if (!selected || !selected.URLs || !serverInfo) return [];

    return selected.URLs.map((item) => {
      if (item.URL === 'https://' + serverInfo.Url + '/') {
        return {
          ...item,
          max: serverInfo.Maximum + ' ms',
          min: serverInfo.Minimum + ' ms',
          average: serverInfo.Average + ' ms',
        };
      }

      return item;
    });
  });

  getDeviceStatusList = computed(() => {
    return this.selectedItem()?.deviceStatusList ?? [];
  });

  getSessionStatus = computed(() => {
    return this.selectedItem()?.sessionStatus;
  });

  ngOnInit() {
    this.initTableCols();
  }

  onHideDialog() {
    this.selectedItem.set(null);
  }

  initTableCols() {
    this.cols = [
      { key: 'URL', label: 'URL' },
      { key: 'status', label: 'URL Status', template: this.statusColumnTemplate() },
      { key: 'responseTime', label: 'Respond Time', template: this.respondTimeColumnTemplate() },
    ];
  }
}
